import { cloneDeep } from 'lodash';

const loading = (state, payload) => {
  const newState = cloneDeep(state);
  newState.loading = payload.loading || false;
  return newState;
};

export { loading };
